import API from '@/lib/API.js'
import comun from './comun.js'
const parentesco = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined
        },
        set(state, valor) {
            state.Lista = valor;
        },
        select(state, valor) {
            state.Seleccionado = valor;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getParentesco();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Parentesco.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, valor) {
            commit("select", valor)
        },
        async AgregarTipoDocumentacion({
            commit,
            state,
            rootState
        }, valor) {
            let p = await API.Tipo_documentaciones_parentesco.Agregar(state.Seleccionado.id_parentesco, valor.id_tipo_documentaciones, valor.Obligatorio);
            rootState.tipodocumentacionestipoafiliacion.Lista.push(p)
            commit("comun/mostrar", "Documentacion guardada")
        },
        async QuitarTipoDocumentacion({
            commit,
            state,
            rootState
        }, id_tipo_documentaciones) {
            let p = await API.Tipo_documentaciones_parentesco.Quitar(id_tipo_documentaciones, state.Seleccionado.id_parentesco);
            rootState.tipodocumentacionestipoafiliacion.Lista =
                rootState.tipodocumentacionestipoafiliacion.Lista.filter((x) => x.id_tipo_documentaciones !== id_tipo_documentaciones)
            commit("comun/mostrar", "Documentacion guardada")
        },
    },
    getters: {
        getParentesco: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default parentesco;